import request from "@/utils/request";

export default function bindCamera(data) {
    return request({
        url: `/camera/bind`,
        method: 'post',
        data
    })
}